import Karte from "./karte";
import CountryLanguage from './../country-language';

/**
 * @typedef {Object} Dataset
 * @property {BZQConfig} config
 */
/**
 * @typedef {Object} BZQConfig
 * @property {string} locale
 * @property {string} app_rpc_bezugsquellen_init
 * @property {string} app_rpc_bezugsquellen_query
 * @property {string} app_rpc_bezugsquellen_laender
 * @property {string} texte
 */
/**
 * @typedef {Object} Land
 * @property {string} country_key
 * @property {string} country_name
 * @property {Number} _ad_ids_sum
 */
/**
 * @typedef {Object} Zielgruppe
 * @property {string} zielgruppe_bezeichnung
 * @property {Number} _ad_ids_sum
 * @property {Number} gebiet_anzahl
 */
/**
 * @typedef {Object} Suchinteresse
 * @property {string} suchinteresse_icon_url
 * @property {string} suchinteresse_bezeichnung
 */
/**
 * @typedef {Object} Bereich
 * @property {string} bereich_bezeichnung
 * @property {Number} _ad_ids_sum
 */
/**
 * @typedef {Object} Serie
 * @property {string} serie_bezeichnung
 * @property {Number} _ad_ids_sum
 */

export default {
	components: {Karte},
	data()
	{
		return {
			b_show_sums          : false,
			b_mounted            : false,
			b_working            : false,
			handle_change_counter: 0,
			min_search_count     : 5,

			/** @type {Land[]} */
			zuordnungenLaender: [],

			land   : null,
			laender: [],

			zielgruppe_id: null,
			/** @type {Zielgruppe[]} */
			zielgruppen: [],

			suchinteresse_id: null,
			/** @type {Suchinteresse[]} */
			suchinteressen: [],

			bereich_id: null,
			/** @type {Bereich[]} */
			bereiche: [],

			serie_id: null,
			/** @type {Serie[]} */
			serien: [],

			plz                      : '',
			plzContainsGeocoordinates: false,
			plzError                 : false,

			adressenErgebnis    : [],
			adressenSerien      : [],
			adressenErgebnisHtml: ''
		}
	},

	computed: {
		ergebnisseClass()
		{
			return 'crm-suchinteresse-' + this.suchinteresse_id;
		}
	},

	inject: ['dataset'],

	mounted: function()
	{
		// Datasets parsen
		for(let element in this.dataset) {
			this.dataset[element] = JSON.parse(this.dataset[element]);
		}

		this.working();

		this.$http.get(this.dataset.config.app_rpc_bezugsquellen_init).then((response) =>
		{
			if(
				Object.prototype.hasOwnProperty.call(response.data, 'zuordnungen')
				&&
				Object.prototype.hasOwnProperty.call(response.data.zuordnungen, 'zuordnungenLaender')
				&&
				response.data.zuordnungen.zuordnungenLaender instanceof Object
			) {
				this.zuordnungenLaender = response.data.zuordnungen.zuordnungenLaender;
				let country_keys = Object.keys(this.zuordnungenLaender);
				this.land = null;
				// nach dem bevorzugten Land im Browser schauen
				let browser_country = CountryLanguage.getBrowserCountry();
				if(country_keys.includes(browser_country)) {
					this.land = browser_country;
				} else if(CountryLanguage.getCountryFromLocale(this.dataset.config.locale)) {
					this.land = CountryLanguage.getCountryFromLocale(this.dataset.config.locale);
				} else {
					this.land = country_keys[0];	// Vorbelegung
				}
			} else {
				this.zuordnungenLaender = [];
				this.land = null;
			}
		}).finally(() =>
		{
			this.working(false);
			this.b_mounted = true;
		});
	},

	watch: {
		land(/*val, oldVal*/)
		{
			this.changeLand();
		},

		zielgruppen(/*val, oldVal*/)
		{
			this.changeZielgruppe();
		},
		zielgruppe_id(/*val, oldVal*/)
		{
			this.changeZielgruppe();
		},

		suchinteresse_id(/*val, oldVal*/)
		{
			this.changeSuchinteresse();
		},
		suchinteressen(/*val, oldVal*/)
		{
			this.changeSuchinteresse();
		},

		bereich_id(/*val, oldVal*/)
		{
			this.changeBereich();
		},
		bereiche(/*val, oldVal*/)
		{
			this.changeBereich();
		},

		serie_id(/*val, oldVal*/)
		{
			this.changeSerie();
		},
		serie(/*val, oldVal*/)
		{
			this.changeSerie();
		}
	},

	methods: {

		/**
		 * @param {string} key
		 */
		trans(key)
		{
			if(Object.prototype.hasOwnProperty.call(this.dataset.texte, key)) {
				return this.dataset.texte[key];
			} else {
				return key;
			}
		},

		/**
		 * @param {Boolean} on
		 */
		working(on = true)
		{
			this.b_working = on;
		},

		clearErgebnis()
		{
			this.adressenErgebnis = [];
			this.adressenErgebnisHtml = '';
			this.plzError = false;
		},

		changeLand()
		{
			// console.log('changeLand', this.land);
			this.zielgruppen = this.zuordnungenLaender[this.land].zielgruppeList;
			if(Object.keys(this.zielgruppen).length > 0) {
				this.zielgruppe_id = Object.keys(this.zielgruppen)[0];
			}
			this.clearErgebnis();

			this.handleChange();
		},

		changeZielgruppe()
		{
			// console.log('changeZielgruppe', this.zielgruppe_id);
			this.suchinteressen = this.zielgruppen[this.zielgruppe_id].suchinteresseList;
			if(Object.keys(this.suchinteressen).length > 0) {
				this.suchinteresse_id = Object.keys(this.suchinteressen)[0];
			} else {
				this.suchinteresse_id = null;
			}
			this.clearErgebnis();

			this.handleChange();
		},

		changeSuchinteresse()
		{
			// console.log('changeSuchinteresse', this.suchinteresse_id);
			this.bereiche = this.suchinteressen[this.suchinteresse_id].bereichList;
			this.bereich_id = '';
			if(Object.keys(this.bereiche).length > 0) {
				this.bereich_id = Object.keys(this.bereiche)[0];
			}
			this.clearErgebnis();

			this.handleChange();
		},

		changeBereich()
		{
			// console.log('changeBereich', this.bereich_id);
			if(Object.keys(this.bereiche).length > 0 && this.bereich_id) {
				this.serien = this.bereiche[this.bereich_id].serieList;
			} else {
				this.serien = [];
			}
			this.serie_id = '';
			// if(Object.keys(this.serien).length > 0) {
			// 	this.serie_id = Object.keys(this.serien)[0];
			// }
			this.clearErgebnis();

			this.handleChange();
		},

		changeSerie()
		{
			// console.log('changeSerie', this.serie_id);
			this.clearErgebnis();

			this.handleChange();
		},

		/**
		 * @return {boolean}
		 */
		showErrors()
		{
			return !this.b_working && this.plzError;
		},

		/**
		 * @return {boolean}
		 */
		isGeolocationAvailable()
		{
			return "geolocation" in navigator;
		},

		/**
		 * @return {boolean}
		 */
		isSucheMoeglich()
		{
			// TODO: korrekt implementieren
			return this.land != null; //this.adresseContainsGeocoordinates;
		},

		/**
		 * @return {boolean}
		 */
		displaySuchinteressen()
		{
			return Object.keys(this.suchinteressen).length > 0;
		},

		/**
		 * @return {boolean}
		 */
		displayBereiche()
		{
			// console.log(this.bereich_id);
			return (['Ausst', 'BZQ'].includes(this.suchinteresse_id))
				&& (Object.keys(this.bereiche).length > 1);
		},

		/**
		 * @return {boolean}
		 */
		displaySerien()
		{
			return this.displayBereiche() && Object.keys(this.serien).length > 1;
		},

		displayPlz()
		{
			let usesPlz = this.displaySerien()
					|| ['Anspr', 'BZQ'].includes(this.suchinteresse_id)
				// || (['Ausst'].includes(this.suchinteresse_id) && this.suchinteressen[this.suchinteresse_id]._ad_ids_sum > this.min_search_count)
			;

			if(['Anspr'].includes(this.suchinteresse_id)) {
				// Bei der Ansprechpartnersuche muss es mindestens 2 Gebiete geben, damit nach PLZ gesucht wird. Nur
				// bei der Ansprechpartnersuche sind die Gebiete überhaupt relevant.
				if(this.suchinteressen[this.suchinteresse_id].gebiet_anzahl < 2) {
					usesPlz = false;
				}
			}
			if(!usesPlz) {
				this.plz = '';
			}
			return usesPlz;
		},

		displayKarte()
		{
			return ['Ausst', 'FaGH', 'BZQ'].includes(this.suchinteresse_id) && this.adressenErgebnis.length > 0;
		},

		/**
		 * @return {Boolean}
		 */
		displaySuchebutton()
		{
			return !this.automatischSuchen() && this.b_mounted;
		},

		/**
		 // * @param {Event} event
		 */
		onFocusPlz(/*event*/)
		{
			if(this.plzContainsGeocoordinates) {
				this.plz = '';
			}
			this.plzContainsGeocoordinates = false;
		},

		/**
		 * @return {Boolean}
		 */
		automatischSuchen()
		{
			switch(this.suchinteresse_id) {
				case 'Anspr':
					return !this.displayPlz();

				case 'Ausst':
				case 'FaGH':
				case 'BZQ':
					return this.suchinteressen[this.suchinteresse_id]._ad_ids_sum <= this.min_search_count;

				case 'OnShop':
				case 'PlanS':
				case 'Schul':
					return true;
			}

			return false;
		},

		/**
		 * Führt eine automatische Suche durch, wenn bestimmte Bedingungen erfüllt sind
		 */
		handleAutomatischeSuche()
		{
			// console.warn("handleAutomatischeSuche");

			if(this.automatischSuchen()) {
				// console.warn("automatische Suche durchführen ...");
				this.getAdresses();
			}
		},

		handleChange()
		{
			if(this.handle_change_counter === 0) {
				this.$nextTick(() =>
				{
					// Dies wird immer erst nach allen (kaskadierenden) Änderungen des Formulars ausgeführt
					this.handleAutomatischeSuche();
					this.handle_change_counter = 0;
				});
			}
			this.handle_change_counter++;
		},

		onHandleSubmit(event)
		{
			event.preventDefault();
			this.getAdresses();
		},

		/**
		 *
		 * @param {Number} lat
		 * @param {Number} lon
		 */
		adressPutCoordinates(lat, lon)
		{
			this.plz = `${lat},${lon}`;
			this.plzContainsGeocoordinates = true;
		},

		adressCheckRemoveCoordinates()
		{
			if(this.plzContainsGeocoordinates) {
				this.plz = '';
				this.plzContainsGeocoordinates = false;
			}
		},

		/**
		 // * @param {Event} event
		 */
		onClickPlzLocation(/*event*/)
		{
			this.getClientLocation()
				.then((result) =>
				{
					this.adressPutCoordinates(result.coords.latitude, result.coords.longitude);
				})
				.catch((/*reason*/) =>
				{
					// TODO: was tun bei Fehler?
					// console.log(reason);
				})
			;
		},

		getClientLocation()
		{
			if(this.isGeolocationAvailable()) {
				return new Promise((resolve, reject) =>
				{
					navigator.geolocation.getCurrentPosition(resolve, reject);
				});
			} else {
				return null;
			}
		},

		getAdresses()
		{
			this.working();
			this.adressenErgebnis = [];

			this.$http.get(this.dataset.config.app_rpc_bezugsquellen_query, {
				params: {
					land         : this.land,
					zielgruppe   : this.zielgruppe_id,
					suchinteresse: this.suchinteresse_id,
					bereich      : this.bereich_id,
					serie        : this.serie_id,
					plz          : this.plz
				}
			}).then((response) =>
			{
				if(
					Object.prototype.hasOwnProperty.call(response.data, 'adressen')
				) {
					this.adressenErgebnis = response.data.adressen;
					this.adressenSerien = response.data.serien;
				} else {
					this.adressenErgebnis = [];
				}
				if(
					Object.prototype.hasOwnProperty.call(response.data, 'adressen_html')
				) {
					this.adressenErgebnisHtml = response.data.adressen_html;
				} else {
					this.adressenErgebnisHtml = '';
				}

				if(
					Object.prototype.hasOwnProperty.call(response.data, 'plz_status')
				) {
					this.plzError = response.data.plz_status !== true;
				} else {
					this.plzError = false;
				}

			}).catch((/*error*/) =>
			{
				// console.log(error);
			}).finally(() =>
			{
				this.working(false);
			});
		},

		formatDistance(val)
		{
			let nf = new Intl.NumberFormat(undefined, {style: 'unit', unit: 'kilometer', maximumSignificantDigits: 2});
			return nf.format(val);
		}
	}
}
